let DateUtil = {
    name: 'DateUtil',
    readDate: function (date) {
        try {
            //解决ios手机时间格式化NAN问题
            if (typeof (date) == "string" && date.indexOf('-') !== -1) {
                date = date.replace(/-/g, '/');
            }
            date = new Date(date);
        } catch (e) {
            console.error('date error', e)
        }
        return date
    },
    // 转换时间戳
    formatDate(time, fmt = 'yyyy-MM-dd') {
        return this.format(time, fmt);
    },
    // 转换时间戳
    formatTimeStamp(time, fmt = 'yyyy-MM-dd HH:mm:ss') {
        return this.format(time, fmt);
    },
    format(date, fmt = 'yyyy-MM-dd HH:mm:ss') {
        if (typeof date === "string") {
            if (date.indexOf(".") > -1) {
                // 有些日期接口返回带有.0。
                date = date.substring(0, dateStr.indexOf("."));
            }
            // 解决IOS上无法从dateStr parse 到Date类型问题
            date = date.replace(/-/g, '/');
            date = new Date(date)
        }
        let o = {
            "M+": date.getMonth() + 1,                 // 月份
            "d+": date.getDate(),                    // 日
            "H+": date.getHours(),                   // 24小时制
            "h+": date.getHours() % 12,              // 12小时制
            "m+": date.getMinutes(),                 // 分
            "s+": date.getSeconds(),                 // 秒
            "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
            "S": date.getMilliseconds()             // 毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }
        return fmt;
    },
    addDay(date, n) {
        return DateUtil.add(date, n, 'day')
    },
    addHour(date, n) {
        return DateUtil.add(date, n, 'hour')
    },
    addMinute(date, n) {
        return DateUtil.add(date, n, 'minute')
    },
    addSecond(date, n) {
        return DateUtil.add(date, n, 'second')
    },
    //获取前后的时间,n可为负数和小数
    add(date, n, unit) {
        if (!date) {
            return null
        }
        if (typeof date === 'string') {
            date = date.replace(/-/g, "/")
        }
        // let million_second = 0;
        switch (unit) {
            case 'day':
                unit = 1000 * 60 * 60 * 24
                break;
            case 'hour':
                unit = 1000 * 60 * 60
                break;
            case 'minute':
                unit = 1000 * 60
                break;
            case 'second':
                unit = 1000
                break;
        }
        return new Date(date.getTime() + n * unit)
    },
    /**
     * 获取浏览器当前时区
     */
    getTimeZoneCurrent() {
        return Math.abs(new Date().getTimezoneOffset() / 60)
    },
    /**
     * 时区转换
     * @param dateTimeString  原始时间
     * @param fromTimeZone    原始时区
     * @param toTimeZone      目标时区
     * @returns {Date}        目标时间
     */
    parseDateTime(dateTimeString, fromTimeZone, toTimeZone = this.getTimeZoneCurrent()) {
        // 将日期时间字符串分割为日期和时间部分
        var parts = dateTimeString.split(' ');

        // 获取日期和时间部分
        var datePart = parts[0];
        var timePart = parts[1];

        // 分割日期部分为年、月、日
        var dateParts = datePart.split('-');
        var year = parseInt(dateParts[0]);
        var month = parseInt(dateParts[1]) - 1; // 月份从 0 开始计数
        var day = parseInt(dateParts[2]);

        // 分割时间部分为时、分、秒
        var timeParts = timePart.split(':');
        var hours = parseInt(timeParts[0]);
        var minutes = parseInt(timeParts[1]);
        var seconds = parseInt(timeParts[2] || 0); // 如果没有秒，则默认为 0

        // 创建一个新的 Date 对象，使用源时区
        var dateTime = new Date(year, month, day, hours, minutes, seconds);

        // 获取源时区与 UTC 时间的差值，以分钟为单位
        var fromOffset = fromTimeZone * 60;

        // 将源时区的偏移量添加到时间中，以得到 UTC 时间
        dateTime.setMinutes(dateTime.getMinutes() - fromOffset);

        // 获取目标时区与 UTC 时间的差值，以分钟为单位
        var toOffset = toTimeZone * 60;

        // 将目标时区的偏移量添加到时间中，以得到目标时区的本地时间
        dateTime.setMinutes(dateTime.getMinutes() + toOffset);

        // 返回转换后的 Date 对象
        return dateTime;
    },
    getTimeDifference(startTime, endTime) {
        // 将时间转换为毫秒数
        const start = startTime.getTime();
        const end = endTime.getTime();
        console.log(`start=${start},end=${end}`)
        if (end < start) {
           return null
        }
        // 计算时间差（以毫秒为单位）
        let diffInMs = Math.abs(end - start); // 取绝对值防止负数

        // 转换为天、小时、分钟和秒
        const day = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        diffInMs %= 1000 * 60 * 60 * 24;

        const hour = Math.floor(diffInMs / (1000 * 60 * 60));
        diffInMs %= 1000 * 60 * 60;

        const minute = Math.floor(diffInMs / (1000 * 60));
        diffInMs %= 1000 * 60;

        const second = Math.floor(diffInMs / 1000);

        // 返回时间对象
        return {day, hour, minute, second};
    },
    getTime2Num(timeObj){
        let {day, hour, minute, second} = timeObj
        return {
            day:day>9?day:('0'+day),
            hour:hour>9?hour:('0'+hour),
            minute:minute>9?minute:('0'+minute),
            second:second>9?second:('0'+second),
        }
    },
};
export default DateUtil

